import { useEffect } from 'react'
import { gsap, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import styles from './InHouseSupport.module.scss'
import TitleFlex from 'components/services/commons/TitleFlex'

gsap.registerPlugin(ScrollTrigger)

const tweenVars = {
  y: '50',
  duration: 0.5,
  opacity: 0,
  ease: Power1.easeOut,
}

interface Props {
  subTitle: string
  list: {
    text: string
  }[]
  explain?: {
    title?: string
    explanation?: string
  }[]
}

const InHouseSupport: React.FC<Props> = ({ list, explain, subTitle }) => {
  const timeline = gsap.timeline()

  useEffect(() => {
    timeline
      .from('.InHouseSupport_item01', tweenVars, 0.3)
      .from('.InHouseSupport_item02', tweenVars, 0.6)
      .from('.InHouseSupport_item03', tweenVars, 0.9)
      .from('.InHouseSupport_item04', tweenVars, 1.2)

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.InHouseSupport_item01',
      start: 'top 90%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  const InHouseSupportList = list.map((item, index) => (
    <p key={index} className={styles.in_house_support_body_item}>
      {item.text}
    </p>
  ))

  const ExplainList = () => {
    if (!explain) return null

    return explain.map((item, index) => (
      <div key={index} className={styles.in_house_support_body_item_lists}>
        <p className={styles.in_house_support_body_item_lists_title}>{item.title}</p>
        <p className={styles.in_house_support_body_item_lists_explanation}>{item.explanation}</p>
      </div>
    ))
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.inner}>
        <TitleFlex sectionTitle={{ title: 'In-house support', sub_title: subTitle }} adjust />
        <div className={`${styles.in_house_support_body} InHouseSupport_item01`}>
          <div>{InHouseSupportList}</div>
          {ExplainList()}
        </div>
      </div>
    </section>
  )
}

export default InHouseSupport
